import {RequestAnfrage} from "../../model/request.anfrage";

/**
 * Class holds all the data of the request inside the foerdermittelcheck that the user needs for the frontend.
 */
export class FoerdermittelcheckAnfrage implements RequestAnfrage {
  /**
   * holds the last update we did on the local data
   */
  lastupdate: number = null;

  /**
   * holds the currecnty active portalId for this request
   */
  portalId: string = null;

  /**
   * Input of the user
   */
  userInput: any = {};

  /**
   * the main interest
   */
  gefoerdertWird: string[] = [];

  /**
   * gefoerdertWird + gebaeudetyp converted and joined a string
   */
  fundingPath: string = null;

  /**
   * result of the user's dialog registration
   */
  dialogResult: string = null;

  /**
   * Holds the measures from the funding measure api
   */
  measures: any =  {};

  /**
   * Holds the mapping between measures and user input fields
   */
  measuresMapping: {[key: string]: string[]} = {};

  /**
   * Holds the programs from the funding programs api
   */
  programs: any = [];

  /**
   * Holds the OID from the funding programs api
   */
  programIds: any = [] ;

  /**
   * Holds the report url
   */
  report: string = null;

  /**
   * Holds the debug object
   */
  debug: any;

  /**
   * Holds the placeholder object
   */
  placeholder: any = {};

  /**
   * @inheritdoc
   */
  campaignId: string;

  /**
   * @inheritdoc
   */
  lastPath: string;

  /**
   * check if an option is selected in the userinput
   * @param option
   */
  isOptionSelected(option: string): boolean {
    // option must be true or a non empty string
    return this.userInput[option] === true ||
      (typeof this.userInput[option] === "string" && this.userInput[option] !== '');
  }

  /**
   * check if a measure is selected by the user
   * @param measure
   */
  isMeasureSelected(measure: string): boolean {
    if(this.measuresMapping.hasOwnProperty(measure) === false) {
      return false;
    }

    // find the first option that is set in this measure
    return typeof this.measuresMapping[measure].find(option => this.isOptionSelected(option)) !== "undefined";
  }

}
